import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Mercaderia } from 'src/app/model/index.model';
import { MercaderiaService } from 'src/app/service/index.service';
import { FilMercaderiaComponent } from '../../filtro/fil-mercaderia/fil-mercaderia.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-cb-mercaderia-2',
  templateUrl: './cb-mercaderia-2.component.html',
  styleUrls: ['./cb-mercaderia-2.component.css']
})
export class CbMercaderia2Component implements OnInit , OnDestroy{

  @ViewChild("txtcode", { static: false }) txtcode: ElementRef;
  @ViewChild("lunch", { static: false }) lunch: ElementRef;
  @ViewChild('modalContent', { static: false }) modalContent: any;


  @ViewChild(FilMercaderiaComponent, { static: false }) fil: FilMercaderiaComponent;


  @Output() select = new EventEmitter<Mercaderia>();
  @Input() require

  item: Mercaderia;
  items: Mercaderia[];
  focus: boolean = false;
  private modalRef: NgbModalRef;

  indiceActivo: number = -1;  // -1 = ninguno seleccionado


  codigo: string;
  sugerencias: Mercaderia[] = [];
  mostrandoSugerencias = false;

  public entity = "Mercaderia";
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  focusss() {

    // Abro el modal primero
    this.modalRef = this.modalService.open(this.modalContent, { size: 'lg' });
    // Espero un tick de Angular para que se renderice el modal
    setTimeout(() => {
      if (this.fil) {
        this.fil.search = this.codigo;
        this.fil.list();
        this.fil.focusable();
      }
    }, 100);

  }

  
  onKeyDownSugerencia(event: KeyboardEvent, index: number, item: Mercaderia) {
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.indiceActivo = Math.min(this.indiceActivo + 1, this.sugerencias.length - 1);
        break;

      case 'ArrowUp':
        event.preventDefault();
        this.indiceActivo = Math.max(this.indiceActivo - 1, 0);
        break;

      case 'Enter':
        if (this.indiceActivo >= 0 && this.indiceActivo < this.sugerencias.length) {
          event.preventDefault();
          this.seleccionarSugerencia(this.sugerencias[this.indiceActivo]);
        }
        break;

      case 'Escape':
        event.preventDefault();
        this.cerrarSugerencias();
        break;

      case 'Tab':
        // Opcional: cerrar al presionar Tab
        this.cerrarSugerencias();
        break;
    }
  }

  // Método para cerrar las sugerencias
  cerrarSugerencias() {
    this.sugerencias = [];
    this.mostrandoSugerencias = false;
    this.indiceActivo = -1;
  }

 handleKeyDown(event: KeyboardEvent) {
  // Si NO hay sugerencias → solo manejar F2 u otras teclas especiales
  if (!this.mostrandoSugerencias) {
    if (event.key === 'F2') {
      this.focusss();
      event.preventDefault();
    }
    return;
  }

  // Hay sugerencias → controlamos navegación
  switch (event.key) {
    case 'ArrowDown':
      event.preventDefault();
      if (this.indiceActivo < this.sugerencias.length - 1) {
        this.indiceActivo++;
      }
      // Scroll automático al ítem activo (opcional pero mejora UX)
      this.scrollToActiveItem();
      break;

    case 'ArrowUp':
      event.preventDefault();
      if (this.indiceActivo > -1) {
        this.indiceActivo--;
      }
      this.scrollToActiveItem();
      break;

    case 'Enter':
      event.preventDefault();
      if (this.indiceActivo >= 0 && this.indiceActivo < this.sugerencias.length) {
        this.seleccionarSugerencia(this.sugerencias[this.indiceActivo]);
      } else if (this.sugerencias.length > 0) {
        // Si nada seleccionado → elige el primero
        this.seleccionarSugerencia(this.sugerencias[0]);
      }
      break;

    case 'Escape':
      event.preventDefault();
      this.cerrarSugerencias();
      break;

    default:
      // Letras, borrar, etc. → dejar que el input las procese normalmente
      break;
  }
}

  // Método auxiliar para scroll automático (muy útil si hay muchas sugerencias)
  scrollToActiveItem() {
    setTimeout(() => {
      const container = document.querySelector('.sugerencias-container');
      const activeItem:any = document.querySelector('.list-group-item.active');
      if (container && activeItem) {
        const itemTop = activeItem.offsetTop;
        const itemHeight = activeItem.offsetHeight;
        const containerHeight = container.clientHeight;
        const scrollTop = container.scrollTop;

        if (itemTop < scrollTop) {
          container.scrollTop = itemTop;
        } else if (itemTop + itemHeight > scrollTop + containerHeight) {
          container.scrollTop = itemTop + itemHeight - containerHeight;
        }
      }
    }, 0);
  }
  // Actualizá también el input para resetear el índice cuando escribís
  onInputChange() {
    this.indiceActivo = -1;           // reseteamos selección al escribir
    this.searchSubject.next(this.codigo.trim());
  }

  constructor(private wsdl: MercaderiaService, private modalService: NgbModal) {

  }

  ngOnInit() {
    // Debounce: esperar 350ms después de dejar de escribir
    this.searchSubject.pipe(
      debounceTime(350),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(query => {
      if (query.length >= 3) {
        this.buscarSugerencias(query);
      } else {
        this.sugerencias = [];
        this.mostrandoSugerencias = false;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  async buscarSugerencias(query: string) {
    try {
      // Suponiendo que tenés un método en tu servicio
      const data = await this.wsdl.searchBySerie(query);  // ← nuevo método
      const res = JSON.parse(JSON.stringify(data))
      if (res.code === 200) {
        this.sugerencias = res.data || [];
        this.mostrandoSugerencias = this.sugerencias.length > 0;
      }
      if (this.sugerencias.length > 0) {
        this.indiceActivo = 0;           // resaltar el primero automáticamente
      } else {
        this.indiceActivo = -1;
      }
    } catch (err) {
      console.error('Error buscando sugerencias', err);
      this.sugerencias = [];
      this.mostrandoSugerencias = false;
    }
  }

  seleccionarSugerencia(item: Mercaderia) {
    this.codigo = item.serie;
    this.item = item;
    this.sugerencias = [];
    this.mostrandoSugerencias = false;
    // Opcional: enfocar de nuevo el input o pasar al siguiente campo
    this.buscarBySerie(false,0)
  }

  @Input()
  set dibujar(item: Mercaderia) {
    if (item != undefined) {
      this.item = item;
    } else {
      this.item = new Mercaderia();
      this.item.nombre = ""
      this.codigo = "";
    }
  }

  @Input()
  foco(b: Boolean) {

    if (b) {
      this.item = new Mercaderia();
      this.item.nombre = ""
      this.codigo = "";
      this.txtcode.nativeElement.focus();
    }
  }

  compareFn(c1: Mercaderia, c2: Mercaderia): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }


  async filter(f: NgForm) {
    if (f.valid) {
      let fiambre = false
      let precioFiambre;
      if (this.codigo.substring(0, 3) == '200') {
        /* aca tendriamos que cambiar la logica */
        fiambre = true;
        precioFiambre = parseFloat(this.codigo.substring(7, 10) + '.' + this.codigo.substring(10, 13)).toFixed(2)
        this.codigo = this.codigo.substring(0, 7)
      }
      await this.buscarBySerie(fiambre,precioFiambre)

    
    } else {
      alert('Validar');
    }
  }

  async buscarBySerie(fiambre=false,precioFiambre:any){
      let data = await this.wsdl.doFindCode(this.codigo).then()
      let res = JSON.parse(JSON.stringify(data));
      if (res.code == 200) {
        this.item = new Mercaderia();
        if (res.data) {
          this.item = res.data;
          if (fiambre) {
            this.item.precioCon = precioFiambre
            this.item.precioDeb = precioFiambre
            this.item.precioLis = precioFiambre
            this.item.precioCom = parseFloat(precioFiambre) / 1.17
          }
          console.log(this.item.precioCom)
          this.select.emit(this.item);
        } else {
          this.item = new Mercaderia();
          this.item.nombre = "no se encontro producto";
        }
      } else {
        this.item = new Mercaderia();
        this.item.nombre = "no se encontro producto";

      }

  }
  /* filtro customer */

  doFound(event: Mercaderia[]) {
    this.items = event;
  }

  selected(item) {
    this.codigo = item.serie
    this.select.emit(item);
    if (this.modalRef) {
      this.modalRef.close(); // ✅ cierra bien el modal
    }
  }

}

